import {
  Box,
  Heading,
  Container,
  useColorModeValue,
  VStack,
  Text,
  SimpleGrid,
  Image,
  Link,
  Button,
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const BlogSection = ({ blogLatest }: { blogLatest: any[] }) => {
  const { t } = useTranslation();
  //"gray.800" : "gray.50"
  const bgGradient = useColorModeValue("gray.50", "gray.900");

  return (
    <Box py={20} bgGradient={bgGradient}>
      <Container maxW="container.xl">
        <VStack spacing={12}>
          <VStack spacing={4} textAlign="center">
            <Heading
              size="2xl"
              fontFamily="Nasalization"
              bgGradient="linear(to-r, brand.primary, brand.secondary)"
              bgClip="text"
            >
              {t("blog.title")}
            </Heading>
            <Text
              fontSize="xl"
              color={useColorModeValue("gray.600", "gray.400")}
              maxW="2xl"
            >
              {t("blog.subtitle")}
            </Text>
          </VStack>
          <SimpleGrid columns={{ base: 1, md: 3 }} spacing={8} width="full">
            {blogLatest.map((blog, index) => (
              <BlogCard key={index} {...blog} />
            ))}
          </SimpleGrid>
          <Link href="https://blog.araria.com.br/blog">
            <Button>{t("blog.readMore")}</Button>
          </Link>
        </VStack>
      </Container>
    </Box>
  );
};

// a box, with image as background contain, title and short description inside
const BlogCard = ({ title, description, featuredImage, link }: any) => {
  return (
    <Box position="relative" height="300px" overflow="hidden">
      <Image
        src={featuredImage}
        alt={title}
        width="100%"
        height="100%"
        objectFit="cover"
      />
      <Box
        position="absolute"
        bottom="0"
        left="0"
        right="0"
        bg="rgba(0, 0, 0, 0.6)"
        p={4}
        cursor="pointer"
        _hover={{
          bg: "rgba(0, 0, 0, 0.8)",
        }}
        onClick={() => {
          window.open(link, "_blank");
        }}
      >
        <Heading size="md" color="white" mb={2} noOfLines={4}>
          {title}
        </Heading>
        <Text color="gray.200" noOfLines={2}>
          {description}
        </Text>
      </Box>
    </Box>
  );
};
